import Ajax from "Utils/ajax";
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data);
export const getAllActiveDeactiveStaff = (data) => Ajax.post('hr/getAllActiveDeactiveStaff',data);
export const documentCategory = (data) => Ajax.post('hr/documentCategory',data);
export const documentChecklist = (data) => Ajax.post('hr/documentChecklist',data);